import {
    ChatMessageFieldsFragment,
    NotificationLogMessageFieldsFragment,
    NotificationTemplateFieldsFragment,
} from '~graphql/generated/graphql'

export type NotificationPreviewRef = {
    id: string
    name: string
    postcard_template?: string | null
    subject?: string | null
    body?: string | null
    email_body?: string | null
    postcard_front_html?: string | null
    postcard_back_html?: string | null
}

type MessageWithNotificationRefs =
    | NotificationLogMessageFieldsFragment
    | ChatMessageFieldsFragment

export function resolveNotificationPreviewContent(
    ref: NotificationPreviewRef,
    templates: NotificationTemplateFieldsFragment[],
): NotificationPreviewRef {
    const full = templates.find(t => t.id === ref.id)
    if (!full) return ref

    return {
        id: full.id,
        name: full.name || ref.name,
        postcard_template: full.postcard_template ?? ref.postcard_template,
        subject: full.subject ?? ref.subject,
        body: full.body ?? ref.body,
        email_body: full.email_body ?? ref.email_body,
        postcard_front_html:
            full.postcard_front_html ?? ref.postcard_front_html,
        postcard_back_html: full.postcard_back_html ?? ref.postcard_back_html,
    }
}

export function getMessageNotificationRefs(
    message: MessageWithNotificationRefs,
): NotificationPreviewRef[] {
    const fromJunction =
        message.message_notification_templates?.map(
            m => m.notification_template,
        ) ?? []

    return [message.notification, ...fromJunction].filter(
        (n): n is NonNullable<typeof n> => !!n?.id,
    )
}

export function hasPostcardContent(notification: NotificationPreviewRef): boolean {
    return !!(
        notification.postcard_template ||
        (notification.postcard_front_html && notification.postcard_back_html)
    )
}

export function hasEmailContent(notification: NotificationPreviewRef): boolean {
    return !!(notification.email_body || notification.body || notification.subject)
}
